import React from 'react'
import { Box, Avatar, Stack, useTheme } from '@mui/material'
import { Slide, Rotate } from 'react-awesome-reveal'
import { Group, EmojiEvents, Psychology } from '@mui/icons-material'

export const LeadershipAnimation: React.FC = () => {
    const theme = useTheme()
    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                maxWidth: '900px',
                height: { xs: '300px', md: '500px' },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'visible',
            }}
        >
            {/* Circular gradient background */}
            <Box
                sx={{
                    position: 'absolute',
                    width: { xs: '100%', md: '150%' },
                    height: { xs: '100%', md: '150%' },
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    background: `conic-gradient(from 0deg, 
                        ${theme.palette.primary.light}20,
                        ${theme.palette.secondary.light}20,
                        ${theme.palette.warning.light}20,
                        ${theme.palette.primary.light}20)`,
                    borderRadius: '50%',
                    animation: 'spin 15s linear infinite',
                    '@keyframes spin': {
                        '0%': {
                            transform: 'translate(-50%, -50%) rotate(0deg)',
                        },
                        '100%': {
                            transform: 'translate(-50%, -50%) rotate(360deg)',
                        },
                    },
                }}
            />
            <Stack
                direction="column"
                spacing={3}
                sx={{
                    position: 'relative',
                    zIndex: 1,
                    alignItems: 'center',
                }}
            >
                <Rotate delay={200} triggerOnce>
                    <Avatar
                        sx={{
                            width: { xs: 100, md: 140 },
                            height: { xs: 100, md: 140 },
                            bgcolor: 'primary.main',
                            boxShadow: `0 8px 32px ${theme.palette.primary.main}50`,
                        }}
                    >
                        <Group sx={{ fontSize: { xs: 50, md: 70 } }} />
                    </Avatar>
                </Rotate>
                <Stack direction="row" spacing={2}>
                    <Slide delay={400} direction="left" triggerOnce>
                        <Avatar
                            sx={{
                                width: { xs: 60, md: 80 },
                                height: { xs: 60, md: 80 },
                                bgcolor: 'secondary.main',
                                boxShadow: `0 4px 16px ${theme.palette.secondary.main}40`,
                            }}
                        >
                            <EmojiEvents
                                sx={{
                                    fontSize: { xs: 30, md: 40 },
                                }}
                            />
                        </Avatar>
                    </Slide>
                    <Slide delay={600} direction="right" triggerOnce>
                        <Avatar
                            sx={{
                                width: { xs: 60, md: 80 },
                                height: { xs: 60, md: 80 },
                                bgcolor: 'warning.main',
                                boxShadow: `0 4px 16px ${theme.palette.warning.main}40`,
                            }}
                        >
                            <Psychology
                                sx={{
                                    fontSize: { xs: 30, md: 40 },
                                }}
                            />
                        </Avatar>
                    </Slide>
                </Stack>
            </Stack>
        </Box>
    )
}
